// The `:active_tab` route param values for the asset details page. Mirrors
// EVIDENCE_TAB_SLUGS. Attachments (ENG-1671) lists the asset's general files;
// History (ENG-1001) renders the asset's activity-log feed. "overview" must stay
// in sync with the default-tab redirect in routes.tsx (hardcoded there,
// matching the routes convention).
export const LAB_ASSET_TAB_SLUGS = {
  OVERVIEW: "overview",
  VALIDATIONS: "validations",
  ATTACHMENTS: "attachments",
  // Backed by POST /assets/:uuid/activity-log; the old "activity-log" slug
  // falls through the unknown-slug redirect to Overview.
  HISTORY: "history",
} as const;

export type LabAssetTabSlug =
  typeof LAB_ASSET_TAB_SLUGS[keyof typeof LAB_ASSET_TAB_SLUGS];

const LAB_ASSET_TAB_SLUG_VALUES: readonly string[] =
  Object.values(LAB_ASSET_TAB_SLUGS);

// Route params are free text; the details page redirects anything that isn't
// a known slug to Overview instead of rendering an empty tab body.
export const isLabAssetTabSlug = (slug?: string): slug is LabAssetTabSlug =>
  !!slug && LAB_ASSET_TAB_SLUG_VALUES.includes(slug);
